import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Sparkles } from 'lucide-react';

export interface IWelcomeBannerProps {
  firstName: string;
  activeApplications: number;
}

export const WelcomeBanner = ({ firstName, activeApplications }: IWelcomeBannerProps) => {
  return (
    <Box
      component="section"
      aria-label="Welcome"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #047857 0%, #059669 50%, #10b981 100%)',
        borderRadius: '18px',
        boxShadow: '0 10px 25px -5px rgba(5, 150, 105, 0.25)',
        p: { xs: 3, md: 4 },
        color: '#fff',
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          inset: 0,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -80,
            right: -60,
            width: 280,
            height: 280,
            bgcolor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            filter: 'blur(60px)',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: -100,
            left: '30%',
            width: 320,
            height: 320,
            bgcolor: 'rgba(2, 44, 34, 0.2)',
            borderRadius: '50%',
            filter: 'blur(60px)',
          }}
        />
      </Box>

      <Box sx={{ position: 'relative' }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1, opacity: 0.9 }}>
          <Sparkles size={14} aria-hidden="true" />
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.14em',
              color: 'rgba(255, 255, 255, 0.9)',
            }}
          >
            Candidate workspace
          </Typography>
        </Stack>

        <Typography variant="h1" sx={{ color: '#fff', fontWeight: 700, mb: 1 }}>
          Welcome back, {firstName}!
        </Typography>

        <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.85)' }}>
          You have {activeApplications} active application{activeApplications !== 1 ? 's' : ''} in progress.
        </Typography>
      </Box>
    </Box>
  );
};
